import { defineStore } from 'pinia';
import { actions, getters, state } from '@/stores/methods';

export const useReasonForResolvingStatisticsStore = defineStore('reason-for-resolving-statistics', {
  state: state,
  getters: getters,
  actions: actions,
});
